import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("AdminOrdersSubMenusLinks", {
    attrs: {
      loggedUserData: _vm.loggedUserData,
      isExternal: true
    }
  }), _c("div", {
    staticClass: "content-centered large"
  }, [_vm.isDataLoading ? _c("div", {
    staticClass: "text-center"
  }, [_c(VProgressCircular, {
    attrs: {
      indeterminate: "",
      size: "45",
      width: "3"
    }
  })], 1) : _vm._e(), _vm.isAdminNotConsultant(_vm.loggedUserData) && _vm.order ? _c("AdminOrderSummary", {
    attrs: {
      baseModel: _vm.order,
      loggedUserData: _vm.loggedUserData
    }
  }) : _vm.isDataLoading == false ? _c("Error", {
    attrs: {
      error: _vm.error
    }
  }) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };